<template>
    <div :style="theme.container" class="text-center auth-view">
        <v-header></v-header>
        <router-view></router-view>
    </div>
</template>

<script>
import HeaderStyle from '../../style/header'
import Header from '@/components/Header'

export default {
    name: 'AuthView',
    data () {
        return {
            theme: HeaderStyle
        }
    },
    components: {
        'v-header': Header
    }
}
</script>

<style scoped>
    .auth-view {
        height: 100%;
    }
</style>
